import { FC, ReactElement } from 'react'
import { Icon } from '@iconify/react'

import {
  Dropdown,
  Menu,
  MenuItem,
  useGlobalState,
  useShowMessage,
} from '@pepper/ui'
import { deleteProject as deleteDraft } from '@pepper/utils/src/api/projects/projects'

import styles from './DraftDropdown.module.css'

interface DraftDropdownProps {
  projectId: string
  isPaidDraft?: boolean
}

const DraftDropdown: FC<DraftDropdownProps> = ({
  projectId = '',
  isPaidDraft = false,
}) => {
  const { setPendingSidebarCountKeys } = useGlobalState()
  const showMessage = useShowMessage()

  const handleDeleteDraft = async (): Promise<void> => {
    if (projectId) {
      const { status, error } = await deleteDraft({
        id: projectId,
        type: 'draft',
      })

      if (status === 'ok') {
        setPendingSidebarCountKeys(['allProjectsCount'])
        showMessage({ type: 'success', message: 'Draft deleted successfully' })
      } else if (status === 'error') {
        showMessage({ type: 'error', message: error })
      }
    }
  }

  const dropdownOverlay = (): ReactElement => {
    return (
      <Menu className={styles.dropdownMenu}>
        <MenuItem
          onClick={() => handleDeleteDraft()}
          disabled={isPaidDraft}
          className={styles.dropdownMenuItem}
          data-id="business-project-dropdown-delete-draft-menu-item"
        >
          <Icon icon="fe:trash" width="16" className={styles.dropdownIcon} />
          <span>Delete this draft</span>
        </MenuItem>
      </Menu>
    )
  }

  return (
    <div className={styles.iconContainer}>
      <Dropdown
        trigger={['click']}
        overlay={dropdownOverlay}
        placement="bottomRight"
      >
        <Icon
          icon="fe:elipsis-v"
          width="16"
          className={styles.dropdownIcon}
          data-id="business-draft-dropdown-more-button"
        />
      </Dropdown>
    </div>
  )
}

export default DraftDropdown
